(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1000px)');

  function syncNavExposure() {
    var isDesktop = DESKTOP_MQ.matches;
    var mobileNav = document.querySelector('[data-tcb-mobile-nav]');
    var mobileMenu = document.getElementById('mobile-menu');
    var desktopBar = document.querySelector('[data-tcb-desktop-nav-bar]');

    if (mobileNav) {
      mobileNav.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
    }
    if (mobileMenu && isDesktop) {
      mobileMenu.setAttribute('aria-hidden', 'true');
    }
    if (desktopBar) {
      desktopBar.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
    }
  }

  function initMegaMenuLabels() {
    document.querySelectorAll('.mega-menu__promo-image, .mega-menu__column-image, .nav-bar img, .mobile-menu img').forEach(function (img) {
      if (!img.getAttribute('alt') || img.getAttribute('alt').toLowerCase() === 'image') {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function setHeaderHeight() {
    var header = document.querySelector('[data-section-type="header"]');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
    }
  }

  function boot() {
    syncNavExposure();
    initMegaMenuLabels();
    setHeaderHeight();
    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', syncNavExposure);
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(syncNavExposure);
    }
    window.addEventListener('resize', setHeaderHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
